import React from 'react';
import { useLocation } from 'react-router-dom';

export function useQueryParam(paramKey) {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search).get(paramKey), [paramKey, search]);
}
